import {
    TRACK_SAGA_GET_TRACK,
} from '../actionTypes'

export default trackUuid => ({ type: TRACK_SAGA_GET_TRACK, trackUuid })
